import styled, { css } from 'styled-components';

export interface DayProps {
  isToday?: boolean;
  isWeekend?: boolean;
  isCurrentMonth?: boolean;
}

const CalendarCell = styled.div`
  ${({ theme }) => theme.typography.cell}
  font-weight: bold;
  display: flex;
  flex-direction: column;
  padding: 4px;
  height: 120px;
  background: white;
`;

const CalendarCellName = styled.div`
  ${({ theme }) => theme.typography.label}
  font-weight: bold;
  text-align: center;
  margin: 8px 0;
`;

export const Day = styled(CalendarCell)<DayProps>`
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colorsNew.gray.grayMedium};
  position: relative;

  ${({ isCurrentMonth, theme }) =>
    !isCurrentMonth &&
    css`
      color: ${theme.colorsNew.gray.grayBold};
    `}
  ${({ isWeekend, theme }) =>
    isWeekend &&
    css`
      background: ${theme.colorsNew.gray.grayLight};
    `}
`;

export const WeekTotal = styled(CalendarCell)`
  align-items: flex-end;
  box-shadow: none;
  :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colorsNew.gray.grayMedium};
  }
`;
export const DayNumber = styled.div<Pick<DayProps, 'isToday'>>`
  height: 25px;
  width: 25px;
  flex-basis: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isToday, theme }) =>
    isToday &&
    css`
      border-radius: 50%;
      background: ${theme.colorsNew.product.regular};
      color: ${theme.colorsNew.gray.white};
    `}
`;
export const Weeks = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
`;
export const DayName = styled(CalendarCellName)``;
export const WeekName = styled(CalendarCellName)`
  text-transform: capitalize;
`;
export const CalendarEventList = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
export const DayContextualInfo = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  color: ${({ theme }) => theme.colorsNew.gray.grayMedium};
  text-transform: capitalize;
`;
export const DayHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
